module.exports = __webpack_public_path__ + "static/media/accountant -Nidhin K.B.3baa32c9.JPG";